import nodeRight from "./nodeRight.vue"
export default nodeRight



// WEBPACK FOOTER //
// ./src/pages/recommend/automaticPutin/intellPromotion/component/nodeItem/nodeRight/index.js